/**
 * Keep a map as a file: the picture (SVG) that opens in any browser and drops
 * into slides or a document.
 */

import { mapToSvg, type MapDoc } from './model';
import { sessionToHtml, type SessionExport } from './sessionExport';

function fileName(title: string, extension = 'svg'): string {
  const slug = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
  return `${slug || 'mental-map'}.${extension}`;
}

function download(name: string, content: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function downloadMap(doc: MapDoc, title: string): void {
  download(fileName(title), mapToSvg(doc, title), 'image/svg+xml');
}

/** The whole session — shared models and every map shown — as one page to send round. */
export function downloadSession(session: SessionExport): void {
  download(fileName(session.prompt, 'html'), sessionToHtml(session), 'text/html');
}
